// src/components/tag/TagList.tsx
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../../../firebase/AuthProvider";
import {
    deleteTag,
    getAllTags,
} from "../../../../services/tagServices/TagService";
import { Badge } from "react-bootstrap";
import editicons from '../../../../assets/images/editicons.svg';
import trashicons from '../../../../assets/images/trashicons.svg';
import backarrowbtn from '../../../../assets/images/backarrowbtn.svg';
import './tagcreation.css'
import { toast } from "react-toastify";
import { showConfirmationDialog } from "../../../modal/ConfimationModal/Confimation";
import { getStyledTagColors } from "../../../../utilities/colorUtils";
import Tag from "../../../../interfaces/tag/Tag";

const TagList: React.FC = () => {
    const [tags, setTags] = useState<Tag[] | null>(null);
    const [error, setError] = useState<string>("");
    const { currentUser, currentRoles } = useAuth();

    useEffect(() => {
        if (currentUser) {
            (async () => {
                try {
                    const authToken = await currentUser.getIdToken();
                    const fetchedTags = await getAllTags(authToken);
                    if (!fetchedTags) {
                        setError("Failed to load tags.");
                        return;
                    }
                    setTags(fetchedTags);
                } catch (err: any) {
                    console.error(err);
                    setError(err.toString());
                }
            })();
        }
    }, [currentUser]);

    const handleDelete = async (tagId: number) => {
        if (!currentUser) return;
        const confirm = await showConfirmationDialog();
        if (!confirm) return;

        const authToken = await currentUser.getIdToken();
        const res = await deleteTag(authToken, tagId);
        if (res.success) {
            toast.success(res.message);
            setTags(tags?.filter((t) => t.id !== tagId) || null);
        } else {
            toast.error(res.message);
        }
    };

    if (error) {
        return <div className="text-red-500">{error}</div>;
    }

    const backBtnUrl = () => {
        if (currentRoles?.some((role) => role.name === "OWNER" || role.name === "ADMIN")) {
            return "/dashboard/owner/settings";
        } else {
            return "/settings";
        }
    }

    const defaultTagColor = "#7e57c2"; // A standard gray color

    return (
        <>
            <div className="common_card">
                <div className="top top_bar_flx border_tittle">
                    <div className="top_bar_tittle">
                        <h2>
                            <Link to={backBtnUrl()}><img style={{ width: '1.5rem' }} src={backarrowbtn} alt="Back" /></Link>
                            All Tags
                        </h2>
                    </div>
                    <div className="top_right">
                        <Link to="/tags/new" className="highlight_txt">Create New Tag</Link>
                    </div>
                </div>

                <div className="edit_tag_grid">
                    {tags?.map((tag) => {
                        const { tagColor, textColor } = getStyledTagColors(
                            tag.color,
                            defaultTagColor
                        );

                        return (
                            <div key={tag.id} className="edit_tag_grid_items">
                                <div className="edit_tag_cntnt">
                                    <div className="my_badge">
                                        <Badge
                                            bg="" 
                                            style={{
                                                backgroundColor: tagColor,
                                                color: textColor,
                                                // Removed border: `1px solid ${textColor}`
                                            }}
                                        >
                                            {tag.name}
                                        </Badge>
                                    </div>
                                    <p>{tag.color ? `(${tag.color})` : null}</p>
                                </div>
                                <div className="edit_tag_action">
                                    <Link to={`/tags/edit/${tag.id}`}><img style={{ width: '1.5rem' }} src={editicons} alt="editicons" /></Link>
                                    <button onClick={() => handleDelete(tag.id)} className="text-red-500 hover-underline">
                                        <img style={{ width: '1.5rem' }} src={trashicons} alt="trashicons" />
                                    </button>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </>
    );
};

export default TagList;